export default __webpack_public_path__ + "static/media/ISF_B.bf116a20.svg";